import { render, staticRenderFns } from "./OverlayMainCards.vue?vue&type=template&id=feb9ccb2&scoped=true"
import script from "./OverlayMainCards.vue?vue&type=script&lang=js"
export * from "./OverlayMainCards.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "feb9ccb2",
  null
  
)

export default component.exports